import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=23de9122"
import script from "./Companies.vue?vue&type=script&lang=js"
export * from "./Companies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports